<div
  class="report-table-container"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container
      *ngFor="let column of columnsToDisplay"
      matColumnDef="{{ column.columnName }}"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        [ngClass]="column.width"
        [ngStyle]="{ textAlign: column.headerTextAlign }"
      >
        {{ column.displayName }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        [ngClass]="column.width"
        [ngStyle]="{ textAlign: column.textAlign }"
      >
        {{ element | cellValueFormatter: column }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsStrings"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsStrings"></tr>
  </table>
</div>
